import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

/**
 * Shared wrapper component for page content
 * Provides consistent z-index and layout for content over background slides
 */
const Wrapper = styled('div')`
  height: auto;
  display: flex;
  z-index: 1000;
`;

const PageWrapper = ({ children, ...props }) => (
  <Wrapper {...props}>
    {children}
  </Wrapper>
);

PageWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PageWrapper;
